import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-generic-link',
  templateUrl: './generic-link.component.html',
  styleUrls: ['./generic-link.component.scss'],
  imports: [NgTemplateOutlet, RouterLink, MatIcon],
})
export class GenericLinkComponent {
  private readonly protocolRegex: RegExp = /^https?:\/\//i;
  backendURL: string = null;
  isMobile = false;
  cxMobileWidth = this.breakpointService.getSize(BREAKPOINT.sm);
  @Input() url: string | any[];
  @Input() target: string;
  @Input() class: string;
  @Input() id: string;
  @Input() style: string;
  @Input() title: string;
  @Input() icon: string;
  @Input() linkIconSrc: string;
  @Input() linkIconStyleClass: string;
  @Input() location: string;

  baseUrl = this.meta.getTag('name=occ-backend-base-url').content;

  get rel() {
    return this.target === '_blank' ? 'noopener' : null;
  }

  get routerUrl(): any[] {
    if (typeof this.url === 'string') {
      return [this.getAbsoluteUrl(this.url)];
    }
    return this.url;
  }

  isExternalUrl(): boolean {
    return typeof this.url === 'string' && this.protocolRegex.test(this.url);
  }

  isDesktop(): boolean {
    return this.deviceService.isDesktop();
  }

  private getAbsoluteUrl(url: string) {
    const finalURL = this.baseUrl + this.url;
    return url.startsWith('/') && this.location !== 'footer' ? finalURL : '/' + this.url;
  }

  constructor(
    private meta: Meta,
    private deviceService: DeviceDetectorService,
    private breakpointService: BreakpointService
  ) {}

  setImageUrl(media: string): string {
    return this.baseUrl + media;
  }
}
